import { Component } from "@angular/core";

/**
 * ClassicShellComponent — content-area host for the "Clio Classic" V1-faithful
 * reporting experience inside the V2 SPA (ClioAdmin #71, Phase 4 / B1).
 *
 * The Phase-1 horizontal tab bar is SUPERSEDED by the config-driven Classic nav
 * in the V2 left sidebar (CLASSIC_NAV → pagelayout). This component is now a
 * thin host wrapping a nested <router-outlet> in `.classic-shell` — the
 * content-area hook B2 styles. The `/classic/*` routes are unchanged; children
 * reuse the already-declared MSX components (Aurora-backed via clio-server
 * /msx/*) — B1 does NOT rebuild reports, it re-presents them under the classic
 * chrome.
 */
@Component({
    selector: "app-classic-shell",
    templateUrl: "./classic-shell.component.html",
    styleUrls: ["./classic-shell.component.scss"],
})
export class ClassicShellComponent {}
